"use client";
import { showNotification as showNotification$1, hideNotification as hideNotification$1, cleanNotifications as cleanNotifications$1, cleanNotificationsQueue as cleanNotificationsQueue$1, updateNotification as updateNotification$1 } from "@mantine/notifications";
import { resolveType } from "./Notification.helpers.js";
import { rem } from "@mantine/core";
const showNotification = (props) => {
  const resolvedType = resolveType(props);
  return showNotification$1({
    ...props,
    message: props.text,
    loading: props.loading,
    icon: resolvedType.icon,
    title: resolvedType.title,
    styles: (theme) => ({
      root: {
        borderRadius: rem("10px"),
        maxWidth: "40em",
        backgroundColor: theme.other.colorTokens.feedback[resolvedType.color]
      },
      icon: {
        backgroundColor: "transparent"
      },
      title: {
        color: "var(--figurine-body-white)"
      },
      description: {
        color: "var(--figurine-body-white)"
      },
      closeButton: {
        color: "var(--figurine-body-white)",
        backgroundColor: "transparent"
      }
    })
  });
};
const updateNotification = (props) => {
  const resolvedType = resolveType(props);
  const formattedProps = {
    ...props,
    message: props.text,
    loading: props.loading,
    icon: resolvedType.icon,
    title: resolvedType.title,
    styles: (theme) => ({
      root: {
        border: "none",
        boxShadow: theme.shadows.lg,
        borderRadius: theme.radius.md,
        maxWidth: "40em",
        backgroundColor: theme.other.colorTokens.feedback[resolvedType.color]
      },
      icon: {
        backgroundColor: "transparent"
      },
      title: {
        color: theme.other.colorTokens.body.light
      },
      description: {
        color: theme.other.colorTokens.body.light
      },
      closeButton: {
        color: theme.other.colorTokens.icons.light,
        "&:hover": {
          background: "transparent"
        }
      }
    })
  };
  return updateNotification$1(formattedProps);
};
const hideNotification = hideNotification$1;
const cleanNotifications = cleanNotifications$1;
const cleanNotificationsQueue = cleanNotificationsQueue$1;
export {
  cleanNotifications,
  cleanNotificationsQueue,
  hideNotification,
  showNotification,
  updateNotification
};
